import { get } from 'lodash';
import { getQuery } from 'client/utils/location';
import { objectToQueryString } from 'site-modules/shared/utils/string';
import { generateRelLink } from 'site-modules/shared/pages/seo';

export function getSeoUrlsByLocation({ pathname, search = '' }, { totalPages }) {
  const queryObj = getQuery({ search });
  const currentPage = parseInt(get(queryObj, 'pagenum', 1), 10);

  const seoUrls = {};

  // build the next link when appropriate
  if (currentPage < totalPages) {
    queryObj.pagenum = currentPage + 1;
    seoUrls.next = generateRelLink(`${pathname}?${objectToQueryString(queryObj)}`);
  }

  // build the prev link when appropriate
  if (currentPage === 2) {
    // the first page should not have pagenum=1 in the url
    const queryWithoutPage = objectToQueryString({ ...queryObj, pagenum: undefined });
    seoUrls.prev = generateRelLink(`${pathname}${queryWithoutPage ? `?${queryWithoutPage}` : ''}`);
  } else if (currentPage !== 1) {
    queryObj.pagenum = currentPage - 1;
    seoUrls.prev = generateRelLink(`${pathname}?${objectToQueryString(queryObj)}`);
  }

  return seoUrls;
}
